// extracted by mini-css-extract-plugin
module.exports = {"title":"PopUpSubMenuItem_title__31j4K","item":"PopUpSubMenuItem_item__1ND7q"};